// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import './config'
import App from './App'
import router from './router'
import store from './store/index'
import vuetify from './config/vuetify' // path to vuetify export
Vue.config.productionTip = false

{
  const dateFormater = new Intl.DateTimeFormat(['en-US'], {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    timeZoneName: 'short'
  })
  const tzRegex = /\+(\d\d)(\d\d)/
  Vue.filter('formatDate', function(value) {
    return value !== undefined ? dateFormater.format(new Date(value.replace(tzRegex, '+$1:$2'))).replace(',', '') : undefined
  })
  Vue.filter('formatBytes', function(bytes) {
    if (bytes === 0) return '0 Bytes'
    const k = 1024
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

    const i = Math.floor(Math.log(bytes) / Math.log(k))

    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i]
  })
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  vuetify,
  router,
  store,
  components: { App },
  created: function() {
    store.dispatch('oktaGroups/getOktaGroups')
  },
  template: '<App/>'
})
